import { BpSegmentButtonOption } from "@modules/core/components/bp-segment-button/bp-segment-button.component";
import { BpOption } from "@models/ui-components/bp-option";
import { TimePeriod } from "../../api/graphql/bff/generated/types.graphql-gen";

/**
 * Timespan properties to be used inside the app for anything timespan related.
 * For communication with APIs, some minor changes are made to adjust them for specific endpoints
 * (done directly in the remote, e.g. portfolio performance to adjust to "six_month")
 */
export enum Timespan {
	Day = "day",
	Week = "week",
	Month = "month",
	SixMonths = "six-months",
	Year = "year",
	FiveYears = "five-years",
	Max = "max"
}

export const TIMESPAN_LABEL_SHORT_DAY = "last_24h";
export const TIMESPAN_LABEL_SHORT_WEEK = "last_week";
export const TIMESPAN_LABEL_SHORT_MONTH = "last_month";
export const TIMESPAN_LABEL_SHORT_SIX_MONTHS = "last_six_month";
export const TIMESPAN_LABEL_SHORT_YEAR = "last_year";
export const TIMESPAN_LABEL_SHORT_FIVE_YEARS = "last_five_years";
export const TIMESPAN_LABEL_SHORT_PORTFOLIO_MAX = "last_max";

export const TIMESPAN_LABEL_LONG_DAY = "interval_1_day";
export const TIMESPAN_LABEL_LONG_WEEK = "interval_1_week";
export const TIMESPAN_LABEL_LONG_MONTH = "interval_1_month";
export const TIMESPAN_LABEL_LONG_SIX_MONTHS = "interval_1_six_month";
export const TIMESPAN_LABEL_LONG_YEAR = "interval_1_year";
export const TIMESPAN_LABEL_LONG_FIVE_YEARS = "interval_1_five-years";
export const TIMESPAN_LABEL_LONG_PORTFOLIO_MAX = "interval_1_max";

export const TIMESPAN_OHLC_SEGMENT_BUTTON_OPTIONS: BpSegmentButtonOption[] = [
	{
		name: TIMESPAN_LABEL_SHORT_DAY,
		value: Timespan.Day
	},
	{
		name: TIMESPAN_LABEL_SHORT_WEEK,
		value: Timespan.Week
	},
	{
		name: TIMESPAN_LABEL_SHORT_MONTH,
		value: Timespan.Month
	},
	{
		name: TIMESPAN_LABEL_SHORT_SIX_MONTHS,
		value: Timespan.SixMonths
	},
	{
		name: TIMESPAN_LABEL_SHORT_YEAR,
		value: Timespan.Year
	},
	{
		name: TIMESPAN_LABEL_SHORT_FIVE_YEARS,
		value: Timespan.FiveYears
	}
];

export const TIMESPAN_OHLC_OPTIONS: BpOption<string, Timespan>[] = [
	{
		label: TIMESPAN_LABEL_SHORT_DAY,
		value: Timespan.Day
	},
	{
		label: TIMESPAN_LABEL_SHORT_WEEK,
		value: Timespan.Week
	},
	{
		label: TIMESPAN_LABEL_SHORT_MONTH,
		value: Timespan.Month
	},
	{
		label: TIMESPAN_LABEL_SHORT_SIX_MONTHS,
		value: Timespan.SixMonths
	},
	{
		label: TIMESPAN_LABEL_SHORT_YEAR,
		value: Timespan.Year
	},
	{
		label: TIMESPAN_LABEL_SHORT_FIVE_YEARS,
		value: Timespan.FiveYears
	}
];

export const TIMEPERIOD_OHLC_OPTIONS: BpOption<string, TimePeriod>[] = [
	{
		label: TIMESPAN_LABEL_SHORT_DAY,
		value: TimePeriod.Day
	},
	{
		label: TIMESPAN_LABEL_SHORT_WEEK,
		value: TimePeriod.Week
	},
	{
		label: TIMESPAN_LABEL_SHORT_MONTH,
		value: TimePeriod.Month
	},
	{
		label: TIMESPAN_LABEL_SHORT_SIX_MONTHS,
		value: TimePeriod.SixMonths
	},
	{
		label: TIMESPAN_LABEL_SHORT_YEAR,
		value: TimePeriod.Year
	},
	{
		label: TIMESPAN_LABEL_SHORT_FIVE_YEARS,
		value: TimePeriod.FiveYears
	}
];

// these differ from other options by having slightly different "6m" value and "max" instead of "5y"
export const TIMESPAN_PORTFOLIO_OPTIONS: BpOption<string, Timespan>[] = [
	{
		label: TIMESPAN_LABEL_SHORT_DAY,
		value: Timespan.Day
	},
	{
		label: TIMESPAN_LABEL_SHORT_WEEK,
		value: Timespan.Week
	},
	{
		label: TIMESPAN_LABEL_SHORT_MONTH,
		value: Timespan.Month
	},
	{
		label: TIMESPAN_LABEL_SHORT_SIX_MONTHS,
		value: Timespan.SixMonths
	},
	{
		label: TIMESPAN_LABEL_SHORT_YEAR,
		value: Timespan.Year
	},
	{
		label: TIMESPAN_LABEL_SHORT_PORTFOLIO_MAX,
		value: Timespan.Max
	}
];

export const TIMESPAN_OHLC_FILTERED_OPTIONS: BpOption<string, Timespan>[] = TIMESPAN_OHLC_OPTIONS.filter(
	(t) => t.value !== Timespan.SixMonths && t.value !== Timespan.FiveYears
);

// excludes "6m" and "5y" (to be removed soon)
export const TIMESPAN_PORTFOLIO_FILTERED_OPTIONS: BpOption<string, Timespan>[] = TIMESPAN_PORTFOLIO_OPTIONS.filter(
	(t) => t.value !== Timespan.SixMonths && t.value !== Timespan.Max
);
